import { PAYMENT_INFORMATION } from "./policy-view";

export * from "./policy-view";

export const MORTGAGEE_INFORMATION = [
  { label: "Primary Mortgagee", key: "MortgageeNumber1" },
  {
    label: "Primary Address",
    key: {
      $1: "Mortgagee1AddressLine1",
      $2: "Mortgagee1AddressLine2",
      $3: "Mortgagee1AddressCity",
      $4: "Mortgagee1AddressState",
      $5: "Mortgagee1AddressZip"
    },
    template: "$1 $2 $3, $4 $5"
  },
  { label: "Primary Loan Number", key: "LoanNumber1" },
  { label: "Secondary Mortgagee", key: "MortgageeNumber2" },
  {
    label: "Secondary Address",
    key: {
      $1: "Mortgagee2AddressLine1",
      $2: "Mortgagee2AddressLine2",
      $3: "Mortgagee2AddressCity",
      $4: "Mortgagee2AddressState",
      $5: "Mortgagee2AddressZip"
    },
    template: "$1 $2 $3, $4 $5"
  },
  { label: "Secondary Loan Number", key: "LoanNumber2" }
];

export const HEADERS = [
  {
    name: "Payment Information",
    context: PAYMENT_INFORMATION
  },
  {
    name: "Billing Summary",
    context: [
      {
        label: ({ TotalPremiumLabel = "Premium" }) =>
          `Last Updated ${TotalPremiumLabel}`,
        key: "TotalPremium",
        type: "currencyPrecise"
      },
      {
        label: "Total Balance",
        key: "OutstandingBalance",
        location: "accounting",
        type: "currencyPrecise",
        defaultValue: "0"
      },
      {
        label: "Invoice Amount",
        key: "InvoiceAmountCurrent",
        location: "accounting",
        type: "currencyPrecise",
        defaultValue: "0"
      },
      {
        label: "Minimum Payment",
        key: "MinimumPaymentDue",
        location: "accounting",
        type: "currencyPrecise",
        defaultValue: "0"
      },
      {
        label: "Payment Due Date",
        key: "InvoiceDueDateCurrent",
        location: "accounting",
        type: "date"
      }
    ]
  }
];
